import { ExtSearchService } from './../../../../services/ext-search/ext-search.service';
import { QueryBuilderConfig } from 'angular2-query-builder';
import { DataTable } from 'primeng/primeng';
import { CalendarTranslateService } from './../../services/calendarTranslate.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { ColumnReport } from './../../../../models/report.model';
import { Component, ViewChild, ElementRef, OnInit, Input, Output, EventEmitter, ViewContainerRef, TemplateRef, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../../services/user/auth.service';
import { Service } from '../../../../models/service.model';
import { Observable } from 'rxjs/Rx';
import { ConfirmationService, MessageService, SortEvent } from 'primeng/api';
import { UsersService } from '../../../../services/user/users.service';
import { Permission } from '../../../../models/permission.model';
import { AppComponent } from 'app/app.component';
import { Report } from 'app/models/report.model';
import { Router } from '@angular/router';
import { ReportComponent } from '../report/report.component';
import { group } from '@angular/core/src/animation/dsl';
import { Services } from '@angular/core/src/view';
import { CRUDNames, KonPermission, Column, Filter, REPORT_TYPE } from './../kontable/utility/utility-model';
import { UtilityReport } from './../kontable/utility/utility-report';
import { LoyaltyChannelService } from '../../../../services/loyalty/loyalty-channel.service';
import { StoreCommonService } from '../../../../services/store/store-common.service';
import { LoyaltyClusterService } from '../../../../services/loyalty/loyalty-cluster.service';
import * as moment from 'moment';
import { PermsService } from '../../../../services/utils/perms.service';
import { LoyaltyParamsService } from '../../../../services/loyalty/params.service';
// this is for Stimulsoft
declare var Stimulsoft: any;
declare var System: any;

// this is for jQuery
declare var $: any;


@Component({
  selector: 'app-kontablenew',
  templateUrl: './kontablenew.component.html',
  styleUrls: ['./kontablenew.component.css']
})

export class KontableNewComponent implements OnInit, OnChanges {

  public static signalDataChange: EventEmitter<any> = new EventEmitter<any>();

  public static StandardLayout = 'standard';

  public static NoPagination = 0;
  public static ClientPagination = 1;
  public static ServerPagination = 2;

  public static NoFilter = 0;
  public static TextFilter = 1;
  public static SelectFilter = 2;
  public static MultiselectFilter = 4;
  public static CustomFilter = 5;
  public static NumberFilter = 6;
  public static DateFilter = 7;

  public static UnknownType = 'unknown';
  public static IntegerType = 'integer';
  public static CurrencyType = 'currency';
  public static StringType = 'string';

  // begin variabili usate solo in  template per problemi di reference variabili static; todo: trovare il modo di eliminarle
  public serverPagination = KontableNewComponent.ServerPagination;
  public textFilter = KontableNewComponent.TextFilter;
  public numberFilter = KontableNewComponent.NumberFilter;
  public selectFilter = KontableNewComponent.SelectFilter;
  public multiselectFilter = KontableNewComponent.MultiselectFilter;
  public customFilter = KontableNewComponent.CustomFilter;
  public standardLayout = KontableNewComponent.StandardLayout;
  public noPagination = KontableNewComponent.NoPagination;
  public dateFilter = KontableNewComponent.DateFilter;

  public konReport: Report;

  private refreshCounter = 0;

  public showReportButton = -1; //imposto la variabile a -1: mi baso sull'input della kontable figlia ->[showReport]=false/true
  // end variabili usate solo in  template per problemi di reference variabili static; todo: trovare il modo di eliminarle

  // https://blog.angular-university.io/angular-ng-template-ng-container-ngtemplateoutlet/
  @Input() additionalRowCommands: TemplateRef<any>;
  @Input() infoDialogBodyTemplate: TemplateRef<any>;
  @Input() layout: string = KontableNewComponent.StandardLayout;
  @Input() title: string;
  @Input() columns: any;
  @Input() orderable: boolean = true;
  @Input() titles: Array<string>;
  @Input() paginationType: number = KontableNewComponent.ClientPagination;
  @Input() service: any;
  @Input() methodsNames: CRUDNames = { list: 'list', sendExtSearchQuery: 'sendExtSearchQuery' };
  @Input() propertyPrefix = '';
  @Input() source: any;
  @Input() searchDelay = 400;
  @Input() searchMinLen = 3;
  @Input() rowsPerPage: number;
  @Input() rowsPerPageOptions: Array<number>;
  @Input() showGlobalFilter = true;
  @Input() showIncludeDeleted = false;
  @Input() sortableColumns: boolean;
  @Input() searchableColumns: boolean;
  @Input() columnFiltersEnabled = true;
  @Input() page: number;
  @Input() showAddButton = false;
  @Input() alternateRows = true;
  @Input() showEditButton = true;
  @Input() showDeleteButton = true;
  @Input() showInfoButton = true;
  @Input() showRecoverButton = true;
  @Input() showRolesButton = false;
  @Input() showDetailsButton = true;
  @Input() showTotalPages = true;
  @Input() showTotalRecord = true;
  @Input() defaultRowsPerPageOptions = [5, 10, 20, 50, 100];
  @Input() fixedFilters = [];
  @Input() fireNewDataAvailable = false;
  @Input() konPermissions: KonPermission = new KonPermission();
  @Input() servicePermissions: Permission;
  @Input() toolbarCustomButtons: TemplateRef<any>;
  @Input() name: string;
  @Input() showCardHomingBtns = false;

  // if true, show report button;
  @Input() showReport = true;
  @Input() blankReport = false;

  // if true, show download excel button;
  @Input() showDownloadExcelBtn = false;

  @Input() reportColumnWidth: number[] = undefined;
  @Input() reportColumnType: REPORT_TYPE[] = undefined;
  @Input() reportColumnAlignment: string[] = undefined;
  @Input() isReportHor = false;

  // Attiva i filtri per singola colonna. Se false, mostra il tasto "Applica Filtri" per filtraggio simultaneo di tutte le colonne
  @Input() filterBySingleColumn = true;

  // Button reset filtri
  @Input() showResetFiltersBtn = true;

  // Aggiunge o toglie la colonna di button delle row (button edit, delete, info... ecc...), default true
  @Input() showRowButtons = true;


  exportReportRows: any;
  // Extended Search
  extSearchQuery: any;
  extSearchConfig: QueryBuilderConfig;
  extSearchSortField: string;
  extSearchSortDir: number;
  filteredByExtSearch = false;
  @Input() showExtSearch = false;
  @Input() extSearchConfigKey: string;
  @Input() extSearchResult: any;
  @Output() extSearchReq: EventEmitter<any> = new EventEmitter();

  @Output() onAdd = new EventEmitter();
  @Output() onEdit = new EventEmitter();
  @Output() onInfo = new EventEmitter();
  @Output() onDetails = new EventEmitter();
  @Output() onRemove = new EventEmitter<any>();
  @Output() onRecover = new EventEmitter<any>();
  @Output() onCancelDetail = new EventEmitter();
  @Output() selectedItemChange = new EventEmitter();
  @Output() includeDeletedChange = new EventEmitter<any>();
  @Output() fireNewDataAvailableChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() cardHomingOperationType: EventEmitter<string> = new EventEmitter();
  @Output() manageRolesSelected: EventEmitter<any> = new EventEmitter();
  @Output() onDownloadExcel: EventEmitter<any> = new EventEmitter<any>();
  // Pulizia Filtri (utilizzato per filtri Data)
  @Output() onClearFilters: EventEmitter<any> = new EventEmitter<any>();

  // Conferma Prenotazioni Premi
  @Input() showConfirmGiftsBtn = false;
  @Output() onConfirmGifts: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('childViewer') childViewer = ElementRef;
  @ViewChild('dt') dataTable: DataTable;
  @Input() DefaultRowsPerPage = 10;

  selectedItem: any;
  searchTimeout: any;

  cols: Array<Column>;
  filter: Filter;
  orderBy: Array<{type: string, key: string}> = new Array<{type: string, key: string}>();
  data: Array<any>;
  filteredData: Array<any>;
  @Input() totalRecords: number;
  totalPages: number;
  showConfirmActionDialog = false;

  currentInfo: any;
  showInfo = false;
  includeDeleted = false;
  globalFilter: string;
  translations: any;

  showMeReport = false;

  viewer: any;

  emitter = new EventEmitter<any>();

  dialogExists = false;

  private permissions: KonPermission;
  private reportComponent: ReportComponent;

  openExtSearch = false;

  constructor (
    private translate: TranslateService,
    private authService: AuthService,
    private viewContainer: ViewContainerRef,
    private confirmationService: ConfirmationService,
    public srvCalendar: CalendarTranslateService,
    private usersSrv: UsersService,
    private srvNotify: MessageService,
    private appComp: AppComponent,
    private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private utilityReport: UtilityReport,
    private extSearchService: ExtSearchService,
    private channelService: LoyaltyChannelService,
    private storeCommonService: StoreCommonService,
    private clusterService: LoyaltyClusterService,
    private permSrvCommon: PermsService,
    private paramsLoyService: LoyaltyParamsService
  ) {
    let self = this;
    this.translate.get([
      'kontable.delete',
      'kontable.recoverConfirmation',
      'kontable.removeConfirmation',
      'kontable.noInfoData',
    ]).subscribe( res => {
      self.translations = res;
    });
    KontableNewComponent.signalDataChange.subscribe(change => {
      if (change.name === this.name) {
        this.ngOnInit()
      }
    })
  }

  // fixme MAH.
  t(text: string) {
    // traduci la stringa
    console.log('richiesta traduzione:', text, this.translate.instant(text));
    return text;
  }

  // fixme MAH2.
  format(value: any, type: string, translate = false) {
    switch (type) {
      case KontableNewComponent.CurrencyType: {
        if (typeof value !== 'number') {
          value = <number>value;
        }
        return Math.floor(value * 100 ) / 100;
      }

      // fixme MAH3.
      default: {
        if (translate) {
          return this.t(value);
        }
        return value;
      }
    }
  }

  clientSideFilter() {

    if (this.filter) {
      let gFilter = this.globalFilter == null ? '' : this.globalFilter.toLowerCase();
      this.filteredData = this.data.filter((r) => {
        if ((!gFilter || gFilter === '') && this.filter.search.length === 0) {
          return true;
        }

        // Implementare filtraggio e ordinamento
        let globalFilterOk = (!gFilter || gFilter === '');
        let keys = Object.keys(r);
        for (let i = 0; i < keys.length; i++) {
          let k = keys[i];
          if (r[k] && (gFilter && gFilter !== '' && r[k].toString().toLowerCase().indexOf(gFilter) !== -1)) {
            globalFilterOk = true;
            break;
          }
        }

        let allColumnFilters = true;
        for (let i = 0; i < keys.length; i++) {
          let k = keys[i];

          let fieldFilter = this.filter.search.filter(s => s.key === k);
          if (k != 'id') {
            if ((fieldFilter.length > 0 && !r[k] && r[k] != 0) ||
              (fieldFilter.length > 0 && r[k].toString().toLowerCase().indexOf(fieldFilter[0].value.toString().toLowerCase()) === -1)
            ) {
              allColumnFilters = false;
              break;
            }
          } else {  // in caso di filtro per 'id', restituisco solo gli elementi uguali alla stringa cercata e non anche quelli che la contengono solamente
            if ((fieldFilter.length > 0 && !r[k] && r[k] != 0) ||
              (fieldFilter.length > 0 && r[k].toString().toLowerCase() !== fieldFilter[0].value.toString().toLowerCase())
            ) {
              allColumnFilters = false;
              break;
            }
          }
        }
        return allColumnFilters && globalFilterOk;
      });
      this.totalRecords = this.filteredData.length;
      this.totalPages = Math.ceil(this.totalRecords / this.filter.limit);

      if (this.dataTable) {
        this.dataTable.first = 0;  // riporto alla prima pagina dopo filtraggio colonne client side
      }

    }
  }

  globalFilterChange(key) {
    this.globalFilter = key;

    this.refresh();
  }

  ngOnChanges(changes) {
    console.log('===========> in ngOnChanges', changes);

    if (changes.extSearchResult) {
      this.filteredData = changes.extSearchResult.currentValue;
      this.totalPages = Math.ceil(this.totalRecords / 10);
    }

    let refresh = false;
    if (changes.fireNewDataAvailable) {
      this.fireNewDataAvailable = false;
      const self = this;
      setTimeout(function() {
        self.fireNewDataAvailableChange.emit(false);
      }, 100);

      refresh = true;
    } else if (changes.source) {
      refresh = true;
    }

    if (refresh) {
      this.refresh();
    }
  }

  addDefaultEventSubscribers() {
    if(!this.onInfo){
      console.log('===========> in addDefaultEventSubscribers');

      let self = this;
      // Default subscriber per onedit method: show detail panel (con dati...)
      this.onInfo.subscribe(evt => {
        if (evt && evt.user_ins_id && evt.user_ins_id > 0) {
          self.loadInfo(evt).subscribe(res => {
            if (res.error) {
              this.srvNotify.add({severity: 'error', summary: 'Attenzione', detail: res.message });
            } else {
              self.showInfo = true;
              self.currentInfo = res;
            }
          });
        } else {
          self.showInfo = true;
        }

      });
    }

  }

  refresh() {
    this.filteredByExtSearch = false;
    this.data = [];
    if (this.source instanceof Array) {
      if (this.paginationType === KontableNewComponent.ServerPagination) {
        console.warn('serverSide Pagination not allowed with Array Source. Switch to client side');
        this.paginationType = KontableNewComponent.ClientPagination;
      }

      this.data = this.source;
      if (this.totalRecords === undefined && this.source.length !== 0 && this.filter) {
        this.totalRecords = this.source.length;
        this.totalPages = Math.ceil(this.totalRecords / this.filter.limit);
      }

      this.clientSideFilter();
    } else if (this.source instanceof Function) { // fixme forse si può fare meglio sto controllo...?
      this.source();
      if (this.totalRecords === undefined && this.source.length !== 0 && this.filter) {
        this.totalRecords = this.source.length;
        this.totalPages = Math.ceil(this.totalRecords / this.filter.limit);
      }
    } else if (this.source == null) {
      console.debug('kontable source is not defined, must be an instance of an Array or a function, or you need to pass a service');
    }
  }

  ngOnInit() {
    if (this.showExtSearch && this.extSearchConfigKey) {
      this.extSearchService.getExtSearchConfig(this.extSearchConfigKey).subscribe(res => {
        if (res && res.length > 0) {
          if (!this.extSearchQuery) {
            this.extSearchQuery = res[0].configValue.query;
          }
          const configFields = res[0].configValue.QueryBuilderConfig.fields;
          const configFieldsArr = [];
          for (const prop in configFields) {
            //#region Estensione di "ExtSearchConfig" per recuperare dati extra
            if (configFields[prop].hasOwnProperty('service')) {
              const valService = configFields[prop]['service'];
              switch(valService){
                case('channel'):
                this.channelService.list().subscribe(resp => {
                  for(const channel of resp.data){
                    configFields[prop].options.push({ name: channel.channelDescription, value: channel.id });
                  }
                });
                break;
                case('store'):
                this.storeCommonService.getList().subscribe(resp => {
                  for(const store of resp){
                    configFields[prop].options.push({ name: store.name, value: store.id });
                  }
                });
                break;
                case('cluster'):
                this.clusterService.list().subscribe(resp => {
                  for(const cluster of resp.data){
                    configFields[prop].options.push({ name: cluster.description, value: cluster.id });
                  }
                });
                break;
              }
            }
            //#endregion
            if (configFields[prop].hasOwnProperty('id')) {
              configFieldsArr.push({[`${prop}`]: configFields[prop]});
            } else {
              this.extSearchConfig = res[0].configValue.QueryBuilderConfig;
              break;
            }
          }
          if (configFieldsArr.length > 0) {
            configFieldsArr.sort((a, b) => {
              const idA = a[Object.keys(a)[0]]['id'];
              const idB = b[Object.keys(b)[0]]['id'];
              let comparison = 0;
                if (idA > idB) {
                  comparison = 1;
                } else if (idA < idB) {
                  comparison = -1;
                }
                return comparison;
            });
            const configFieldsObject = {fields: {}};
            configFieldsArr.forEach(field => Object.assign(configFieldsObject.fields, field));
            this.extSearchConfig = configFieldsObject;
          };
          // In caso di Extended Search Config valida imposto filtri statici
          if (this.extSearchConfig) {
            this.filterBySingleColumn = false;
          } else if (this.filterBySingleColumn) {
            this.refresh();
          }
        } else if (this.filterBySingleColumn) {
          this.refresh();
        }
      });
    }

    this.paramsLoyService.getParamByKey('REPORT.EXPORT_ROWS').subscribe(res => this.exportReportRows = res.param_code);
    //this.addDefaultEventSubscribers();

    let toTranslate = [];
    if (typeof this.title === 'string' && this.title.length > 0) {
      if (this.title.charAt(0) === '$') {
        toTranslate.push(this.title.substr(1));
      }
    }

    if (this.columns == null || this.columns.lenght === 0) {
      throw new Error('columns is a required non-empty member for kontable');
    }

    this.cols = [];

    let titles_index = 0;

    this.columns.forEach((column) => {
      if (typeof column === 'string' && column.length > 0) {
        let columnDef: Column = { field: column, title: null, titleRef: null, type: KontableNewComponent.UnknownType, searchable: true, sortable: true, filterType: KontableNewComponent.TextFilter};
        if (titles_index < this.titles.length) {
          let t = this.titles[titles_index++];

          if (t.charAt(0) === '$') {
            columnDef.titleRef = t.substr(1);
            toTranslate.push(columnDef.titleRef);
          } else {
            columnDef.title = t;
          }
        } else {
          throw new Error('not enough titles for columns');
        }

        this.cols.push(columnDef);
      } else {
        if (column.field == null || column.field === '') {
          throw new Error('field is a required non-empty member for column');
        } else {
          let columnDef: Column = column;
          if (columnDef.title == null) {
            if (columnDef.titleRef != null) {
              toTranslate.push(columnDef.titleRef);
            } else {
              columnDef.title = column.field;
              columnDef.titleRef = null;
              console.warn('kontable column needs title or titleRef defined. Missing for column ' + columnDef.field + '. set to default (column field)');
            }
          }

          if (columnDef.type == null) {
            columnDef.type = KontableNewComponent.UnknownType;
          }

          if (columnDef.sortable == null) {
            columnDef.sortable = this.sortableColumns;
          }

          if (columnDef.sortable == null) {
            columnDef.sortable = true;
          }

          if (columnDef.searchable == null) {
            columnDef.searchable = this.searchableColumns;
          }

          if (columnDef.searchable == null) {
            columnDef.searchable = true;
          }

          if (columnDef.filterType == null) {
            columnDef.filterType = KontableNewComponent.TextFilter;
          }

          if (columnDef.filterType === KontableNewComponent.SelectFilter || columnDef.filterType === KontableNewComponent.MultiselectFilter) {
            if (columnDef.filterOptions != null) {
              if (columnDef.filterOptions.values == null) {
                if (columnDef.filterOptions.valuesSource == null) {
                  columnDef.filterOptions.values = [];
                  columnDef.filterOptions.values.push({value: null, label: 'All'});
                } else {
                  let labelName = 'description';
                  let valueName = 'description';

                  if (columnDef.filterOptions.valueName != null) {
                    valueName = columnDef.filterOptions.valueName;
                  }

                  if (columnDef.filterOptions.labelName != null) {
                    labelName = columnDef.filterOptions.labelName;
                  }

                  columnDef.filterOptions.valuesSource.subscribe((res) => {
                    columnDef.filterOptions.values = [];
                    columnDef.filterOptions.values.push({value: null, label: 'All'});
                    console.log('options for field ' + columnDef.field, res);
                    res.data.forEach((e) => {
                      columnDef.filterOptions.values.push({value: e[valueName], label: e[labelName]});
                    });
                  });
                }
              }
            } else {
              columnDef.filterOptions = {};
              columnDef.filterOptions.values = [{value: null, label: 'All'}];
            }
          }
          this.cols.push(columnDef);
        }
      }
    });
    if (toTranslate.length > 0) {
      this.translate.get(toTranslate).subscribe((res) => {
        if (this.title.charAt(0) === '$') {
          this.title = res[this.title.substr(1)];
        }
        this.cols.forEach((c, index, arr) => {
          if ( c.title == null ) {
            if ( c.titleRef != null ) {
              arr[index].title = res[c.titleRef];
            }
          }
        });
      });
    }

    // Recupero filtri inseriti prima di destroy del componente
    if (this.service && sessionStorage.getItem(this.service.constructor.name)) {
      const storedFilters = JSON.parse(sessionStorage.getItem(this.service.constructor.name));
      if ('condition' in storedFilters) {
        this.extSearchQuery = storedFilters;
        this.openExtSearch = true;
      } else {
        this.fixedFilters = storedFilters;
      }
    } else if (this.source instanceof Array && sessionStorage.getItem(`${this.title}SourceFilters`)) {
      this.fixedFilters = JSON.parse(sessionStorage.getItem(`${this.title}SourceFilters`));
    }

    this.filter = {offset: 0, limit: 0, sort: null, sort_dir: 1, search: Object.assign([],this.fixedFilters)};

    if (this.paginationType !== KontableNewComponent.NoPagination) {
      this.filter.limit = this.rowsPerPage;

      if (this.filter.limit == null) {
        this.filter.limit = this.DefaultRowsPerPage;
      }

      if (this.page != null) {
        this.filter.offset = ( this.page - 1 ) * this.filter.offset;
      }
    } else {
      this.filter.limit = 0;
      this.filter.offset = 0;
    }

    if (this.service != null) {
      console.log('service is not null');

      if (this.paginationType === KontableNewComponent.ServerPagination) {

        this.source = () => {

          this.fixedFilters.forEach(element => {
            let indexFilter = this.filter.search.findIndex(x=>x.key == element.key);
              if(indexFilter>1){
                this.filter.search[indexFilter].value = element.value;
              }
              else{
                this.filter.search.push(Object.assign({},element));
              }
          });

          this.service[this.methodsNames.list](
            this.filter.search,
            this.page,
            this.rowsPerPage,
            this.orderBy.length > 0 ? this.orderBy : null
          ).subscribe(res => {
            this.data = [];

           if(res){
            this.totalRecords = (res && res.totalElements) ? res.totalElements : 0;
            this.totalPages = (res && res.totalPages) ? res.totalPages : 0;
            this.page = (res && res.currentPage) ? res.currentPage : 0;
            this.rowsPerPage = (res && res.itemPerPage) ? res.itemPerPage : 0;

            for (const single of res.list) {

              Object.keys(single).forEach(key => {

                /* IL SEGUENTE CODICE SERVE PER LA VISUALIZZAZIONE DELLE DATE E ORARIO NEL FORMATO CORRETTO */

                /*** la data zero, cioè 1970-01-01 con orario 000 la tratta come data */
                if (typeof single[key] === 'string' && single[key].indexOf('1970-01-01') !== -1 && (single[key].indexOf("T00:00:00.000+0000")!==-1 || single[key].indexOf("T00:00:00.000+0100")!==-1)) {
                  single[key] = this.datePipe.transform(single[key],this.srvCalendar["calendars"][this.authService.sessionHelper.selectedLanguage].dateFormatFilter);
                }

                /*** becca solo gli orari in quanto i campi SOLAMENTE orari sono del tipo "date" con data zero, cioè 1970-01-01 ***/
                else if (typeof single[key] === 'string' && single[key].indexOf('1970-01-01') !== -1 && (single[key].indexOf("T00:00:00.000+0000")===-1 || single[key].indexOf("T00:00:00.000+0100")===-1)) {
                  single[key] = this.datePipe.transform(single[key],'HH:mm:ss');
                }

                /*** becca solo le date in quanto le date secche senza orari sono del tipo "date" con orario zero ***/
                else if (typeof single[key] == 'string' && (single[key].indexOf("T00:00:00.000+0000")!==-1 || single[key].indexOf("T00:00:00.000+0100")!==-1)) {
                  let dateNum = Date.parse(single[key]);
                  if (dateNum) {
                    single[key] = this.datePipe.transform(single[key],this.srvCalendar["calendars"][this.authService.sessionHelper.selectedLanguage].dateFormatFilter);
                  }
                }
              });

              this.data.push(single);
            }
           }

           this.filteredData = this.data;
          })
        }
      } else {

        //CASO: viene indicato il service ma la paginazione non è server (DA VERIFICARE ANCORA)
        this.source = () => {
          this.service[this.methodsNames.list]().subscribe((res) => {

            this.data = [];

            if(res){
              for (const single of res) {
                this.data.push(single);
              }

              this.totalRecords = this.data.length;
              this.totalPages = Math.ceil(this.totalRecords / this.filter.limit);

              this.clientSideFilter();
            }

          })
        }
      }
    }
    // Lascio la table vuota in caso di staticTable o di Extended Search
    if (this.filterBySingleColumn && !this.showExtSearch) {
      this.refresh();
    }
    // la permission gestisce la visualizzazione o meno del button "Visualizza report". Se la permission non è associata, si mantiene la retrocompatibilità
    // del button ossia la visualizzazione viene gestita dalle kontable "figlie" (showReportButton=-1)
    this.permSrvCommon.getCommonPermission().subscribe((permissions: Permission[]) => {
      permissions.forEach((perm: Permission) => {
        if(perm.operationName === 'show-report-btn') {
          //è presente la nuova operation in common.grant_permission e se è abilitata la GET(true) porto il showReportButton al valore 1 altrimenti(visualizzo il button in UI)
          // se la get non è abilitata ma la permission è comunque presente ed associata a quel ruolo/utente la porto a zero(ed il button non è più visibile in UI): in
          // questa casistica vado a SOVRASCRIVERE il comportamento imposto dalla kontable figlia tramite l'input showReport. Se la permission non è presente, la logica resta
          //legata alla variabile showReport ed al suo valore(defaul è true)
          if (perm.allowsGET)
            this.showReportButton = 1;
          else
            this.showReportButton = 0;
        }
      });
    });

  }

  rowEvent(evt, row, eventType) {
    console.log(row, eventType);

    // reset di alcune variabili dei default event handlers
    this.showInfo = false;
    this.selectedItem = row;
    this.showConfirmActionDialog = false;

    // propagazione eventi
    switch (eventType) {
      case 'add':
        this.onAdd.emit(row);
        break;

      case 'edit':
        this.onEdit.emit(row);
        break;

      case 'info':
        this.onInfo.emit(row);
        break;

      case 'details':
        this.onDetails.emit(row);
        break;

      case 'manage-roles':
        this.manageRolesSelected.emit(row);
        break;

      case 'confirm-remove':

        this.confirmationService.confirm({
          header: `${this.translations['kontable.delete']}!`,
          message: this.translations['kontable.removeConfirmation'],
          accept: () => {
            this.onRemove.emit(row);
          }
        });
        break;

      case 'confirm-recover':
        this.confirmationService.confirm({
          message: this.translations['kontable.recoverConfirmation'],
          accept: () => {

            this.onRecover.emit(row);
          }
        });
        break;
    }

    this.selectedItemChange.emit(row);
  }

  internalIncludeDeletedChanged(evt) {
    console.log('========> internalIncludeDeletedChanged: ', evt);

    this.updateTableFilter('flg_state', evt ? '' : '0', 'equals', 1, 200);

    this.includeDeletedChange.emit(evt);
  }

  loadInfo(record: any) {
    let ids = [];
    if (record.user_ins_id) {
      ids.push(record.user_ins_id);
    }
    if (record.user_upd_id) {
      ids.push(record.user_upd_id);
    }
    if (record.user_del_id) {
      ids.push(record.user_del_id);
    }

    if (ids.length > 0) {
      return new Observable<any> ((observer) => {

        this.usersSrv.getFiltereIdList(ids.join(',')).subscribe(users => {
          const ret = {};

          if (record.user_ins_id) {
            ret['userInsertInfo'] = {
              login: users.find(u => u.id === record.user_ins_id).login,
              insert_timestamp: record.ts_ins
            }
          }

          if (record.user_upd_id) {
            ret['userUpdateInfo'] = {
              login: users.find(u => u.id === record.user_upd_id).login,
              update_timestamp: record.ts_upd
            };
          }

          if (record.user_del_id) {
            ret['userDeleteInfo'] = {
              login: users.find(u => u.id === record.user_del_id).login,
              delete_timestamp: record.ts_del
            }
          }

          observer.next(ret);
        });
      });
    } else {
      return Observable.of({
        error: true,
        message: this.translations['kontable.noInfoData']
      });
    }
  }

  updateTableFilter(field, value, filterType, filterChars = 1, timeoutSecs = 500, applyFilter = false) {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);

      this.searchTimeout = null;
    }

    /*
      in caso di staticTable disattivo il timeout dei filtri in quanto
      l'utente potrebbe applicarli prima che vengano aggiunti all'array (this.filter.search)
    */
    if (!this.filterBySingleColumn) {
      timeoutSecs = 0;
    }
    if (applyFilter) {
      // eseguo la chiamata con i filtri alla pressione del button "Applica Filtri della staticTable"
      this.refresh();
    } else if (value && value.length >= filterChars) {
      this.searchTimeout = setTimeout(() => {
        let searchFilter = this.filter.search.filter(f => f.key === field);
        if (searchFilter.length > 0) {
          searchFilter[0].value = value;
        } else {
          // KS-1496: porto a 0 l'offset del filtro lato server
          this.filter.offset = 0;
          // qui vengono aggiunti i vari filtri alla stringa
          this.filter.search.push({key: field, value: value, filterType: filterType});
          // KS-1496 torno alla prima pagina della Kontable
          this.dataTable.first = 0;
        }
        if (this.filterBySingleColumn) {
          this.refresh();  // qui viene eseguita la chiamata con i filtri
        }

        this.searchTimeout = null;

        if (this.refreshCounter === 0) {
          this.refreshCounter++;
        }
      }, timeoutSecs);
    } else {
      let index = this.filter.search.findIndex(f => f.key === field);
      if (index > -1) {
        this.filter.search.splice(index, 1);
      }

      if (this.refreshCounter > 0) {
        this.refreshCounter = 0;
      }

      if (this.filterBySingleColumn) {
        this.refresh();
      }

    }
  }

  clearFilters() {
    // pulisco i filtri
    //this.columns.forEach(col => this.filter.search[col.field] = null);
    let objectFilterFootprint = Object.assign({},this.filter.search.find(x=>x.key == "footprint"));
    this.filter.search = [];
    if(objectFilterFootprint){
      this.filter.search.push(objectFilterFootprint);
    }

    this.onClearFilters.emit();
    if (this.filterBySingleColumn) {
      this.refresh();
    } else {
      this.filteredData = null; // pulisco i dati della table
      this.filter.offset = 0; // porto a 0 l'offset del filtro
      this.dataTable.first = 0; // torno alla prima pagina della Kontable
      this.totalPages = 0; // azzero conto totale pagine
      this.totalRecords = 0; // azzero totale dati
    }
  }

  onPageChange(event) {
    if (this.filteredByExtSearch) {
      if (this.extSearchSortField && this.extSearchSortDir) {
        this.extSearchReq.emit({query: this.extSearchQuery, offset: event.first, limit: 10, sortField: this.extSearchSortField, sortDir: this.extSearchSortDir});
      } else {
        this.extSearchReq.emit({query: this.extSearchQuery, offset: event.first, limit: 10});
      }
    } else {
      /*
      this.filter.limit = event.rows;
      this.totalPages = Math.ceil(this.totalRecords / this.filter.limit);
      */
      if (this.paginationType === KontableNewComponent.ServerPagination) {
        //this.filter.offset = event.first;
        this.rowsPerPage = event.rows;
        this.page = (event.first > 0) ? (event.first / event.rows) : 0;
        this.refresh();
      }
    }
  }

  getPermissions(): KonPermission {

    if (this.permissions) {
      return this.permissions;
    }

    console.log('Permissions from service:', this.servicePermissions);
    console.log('Permissions from konPerm:', this.konPermissions);

    if (this.servicePermissions) {
      this.permissions = new KonPermission();
      this.permissions.create = this.servicePermissions.allowsPOST;
      this.permissions.view = this.servicePermissions.allowsGET;
      this.permissions.edit = this.servicePermissions.allowsPUT;
      this.permissions.delete = this.servicePermissions.allowsDELETE;
    } else if (this.konPermissions) {
      this.permissions = this.konPermissions;
    }

    return this.permissions;
  }

  onSortData(event: any) {
    this.orderBy = [];
    if (this.paginationType === KontableNewComponent.ServerPagination) {
        this.orderBy.push({type: (event.order == 1 ? "DESC" : "ASC"), key: event.field });
    }
    this.refresh();
  }

  /*** report stimulsoft ***/

  initReport() {
    const self = this;
    const toTranslate = [];

    this.cols.forEach(col => {
      toTranslate.push(col.title);
    });

    this.translate.get(toTranslate).subscribe(data => {

      self.konReport = new Report();
      self.konReport.title = self.title;
      self.konReport.columns = [];

      this.cols.forEach((col, index) => {
        let repCol: ColumnReport = new ColumnReport();
        repCol.alignData = 'left';
        repCol.field = col.field;
        repCol.title = data[toTranslate[index]];
        repCol.width = 0;
        self.konReport.columns.push(repCol);
      });

      self.konReport.data = [];
      self.konReport.company = {
        id: self.appComp['authService'].user.selectedCompany,
        name: ''
      }

      // get company Name
      if (self.konReport.company.id > 0) {
        const companies = self.appComp['authService'].user.companies;
        companies.forEach(company => {
            if (company.id === self.konReport.company.id) {
              self.konReport.company.name = company.descr;
            }
        });
      }

      if (self.service != null && !this.filteredByExtSearch) {
        const self2 = self;

        this.filter.search,
        this.page,
        this.rowsPerPage

        var limitRecordReport = 100;
        // setto il numero di righe esportate nel report in base alla permission presente sullo schema di common
        if(this.exportReportRows != undefined && this.exportReportRows >0)
          limitRecordReport = this.exportReportRows;

        self.service[self.methodsNames.list](
          self2.filter.search,
          this.rowsPerPage,
          limitRecordReport,
          this.orderBy.length > 0 ? this.orderBy : null
        ).subscribe(res => {
          // this.totalRecords = res[this.propertyPrefix + 'metadata'].total;
          for (const single of res[self2.propertyPrefix + 'data']) {
            self2.konReport.data.push(single);
          }
          // self.checkAlign();
          self.viewReport();
        });
      } else if (this.filteredByExtSearch) {
        const extSearchQueryParams = {query: this.extSearchQuery, offset: 0, limit: limitRecordReport}
        if (this.extSearchSortField && this.extSearchSortDir) {
          Object.assign(extSearchQueryParams, {sortField: this.extSearchSortField, sortDir: this.extSearchSortDir});
        }
        self.service[self.methodsNames.sendExtSearchQuery](extSearchQueryParams).subscribe(res => {
          this.filteredData = res.data;
          self.konReport.data = Object.assign([], self.filteredData);
          self.viewReport();
        })
      } else {
          self.konReport.data = Object.assign([], self.filteredData);
          // self.checkAlign();
          self.viewReport();
      }
    });
  }

  /*** view report from Report model ***/
  viewReport() {

    const numColonne = this.cols.length;

    // controllo gli array in @Input, altrimenti stampo il report nella versione base(colonne uguali e senza formattazioni)
    if (!this.reportColumnWidth || this.reportColumnWidth.length !== numColonne) {
      this.reportColumnWidth = undefined;
    }
    if (!this.reportColumnAlignment || this.reportColumnAlignment.length !== numColonne) {
      this.reportColumnAlignment = undefined;
    }
    if (!this.reportColumnType || this.reportColumnType.length !== numColonne) {
      this.reportColumnType = undefined;
    }

    // allinea i dati numerici a destra di default
    this.checkAlign();

    // se il parametro blankReport è specificato allora
    if (this.blankReport) {
      const baseURI = window.document.baseURI;
      sessionStorage.setItem('report', JSON.stringify(this.konReport));
      window.open(baseURI + 'report');
    } else {
      // Change report viewer options
      const options = new Stimulsoft.Viewer.StiViewerOptions();
      // options.appearance.openLinksWindow = "_blank";
      options.appearance.scrollbarsMode = true;
      options.appearance.fullScreenMode = true;

      this.viewer = new Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);
      // var dataSet = new Stimulsoft.System.Data.DataSet();
      // dataSet.readJson(JSON.stringify(this.report.data));
      // var data = dataSet.tables.getByIndex(0);
      const stiReport = new Stimulsoft.Report.StiReport();

      this.isReportHor ? stiReport.loadFile('./assets/report/Report-hor.mrt') : stiReport.loadFile('./assets/report/Report.mrt');

      // page info
      const page = stiReport.pages.getByIndex(0);

      // data values
      const dataBand = stiReport.getComponents().getByName('DataBand1');

      // header fields
      const headerBand2 = stiReport.getComponents().getByName('PageHeaderBand2');

      // const tempColumnWidthStandard = Stimulsoft.Base.StiAlignValue.alignToMinGrid(page.width / this.konReport.columns.length, 0.1, false);

      const pixelToRem = 37.5;

      if (!this.reportColumnWidth) {
        const standardColumnWidth = Stimulsoft.Base.StiAlignValue.alignToMinGrid(page.width / this.konReport.columns.length, 0.1, false);
        this.konReport.columns.forEach((column, index) => {
          column.width = standardColumnWidth;
        });
      } else {
        this.konReport.columns.forEach((column, index) => {
          column.width = this.reportColumnWidth[index] / pixelToRem;   // vecchio valore tempColumnWidthStandard;
        });
      }

      const columnHeight = 0.85;
      let pos = 0;

      this.konReport.columns.forEach((column, index) => {
        const headerText = new Stimulsoft.Report.Components.StiText();
        headerText.clientRectangle = new Stimulsoft.System.Drawing.Rectangle(pos, 0, column.width, 1.0);
        headerText.text = column.title;
        headerText.horAlignment = Stimulsoft.Base.Drawing.StiTextHorAlignment.Center;
        headerText.vertAlignment = 1;
        headerText.name = 'HeaderText_' + index;
        headerText.border.side = Stimulsoft.Base.Drawing.StiBorderSides.All;
        headerText.border.color = Stimulsoft.System.Drawing.Color.white;
        headerText.font = new Stimulsoft.System.Drawing.Font('Calibri', 12, 1);
        headerText.textOptions.wordWrap = true;
        headerText.brush = new Stimulsoft.Base.Drawing.StiSolidBrush(Stimulsoft.System.Drawing.Color.fromArgb(32, 65, 123));
        headerText.textBrush = new Stimulsoft.Base.Drawing.StiSolidBrush(Stimulsoft.System.Drawing.Color.white);

        headerBand2.components.add(headerText);
        pos = pos + column.width;
      });

  let y = 0;
  this.konReport.data.forEach((data, dataIndex) => {
    let x = 0;
    this.konReport.columns.forEach((column, columnIndex) => {

      // Create text on Data Band
      const dataText = new Stimulsoft.Report.Components.StiText();
      dataText.clientRectangle = new Stimulsoft.System.Drawing.Rectangle(x, y, column.width, columnHeight);

      if (!this.reportColumnType) {
        dataText.text = this.utilityReport.getDataText(REPORT_TYPE.STANDARD, data[column.field]);
      } else {
        dataText.text = this.utilityReport.getDataText(this.reportColumnType[columnIndex], data[column.field]);
      }

      if (!this.reportColumnAlignment) {
        dataText.horAlignment = this.utilityReport.getHorAlignment(column.alignData);
      } else {
        dataText.horAlignment = this.utilityReport.getHorAlignment(this.reportColumnAlignment[columnIndex]);
      }

      dataText.textOptions.wordWrap = true;
      // dataText.canGrow = false; // true;
      dataText.name = 'DataText_' + dataIndex + '_' + columnIndex;
      dataText.margins.left = 10;
      dataText.margins.right = 10;
      dataText.margins.top = 10;
      dataText.margins.bottom = 10;

      // Add condition alternate color row
      if (dataIndex % 2 === 1) {
        const condition = new Stimulsoft.Report.Components.StiCondition();
        condition.backColor = Stimulsoft.System.Drawing.Color.fromArgb(135, 225, 255); // 209, 209, 209);
        condition.textColor = Stimulsoft.System.Drawing.Color.black;
        condition.expression = '(Line & 1) == 1';
        condition.item = Stimulsoft.Report.Components.StiFilterItem.Expression;
        dataText.conditions.add(condition);
      }

      dataBand.components.add(dataText);
      x = x + column.width;
    });
    y = y + columnHeight;
  });

      const imageLogo = stiReport.getComponents().getByName('ImageLogo');
      const varInfoCompany = stiReport.dictionary.variables.getByName('var_company');
      const varImage = stiReport.dictionary.variables.getByName('var_image');

      // var baseURI = window.document.baseURI;

      let stiImage;
      if (this.konReport.company.id && this.konReport.company.id > 0) {

        // imageLogo.imageURL = "https://web.koncentro.konvergence.it/assets/layout/images/"+this.report.companyId.toString()+".png";

        stiImage = Stimulsoft.System.Drawing.Image.fromFile('./assets/layout/images/' + this.konReport.company.id + '.png');
        varImage.valueObject = stiImage;
        varInfoCompany.valueObject = this.konReport.company['name'];
      } else {
        varInfoCompany.valueObject = 'Nessuna informazione sull\'azienda';
        stiImage = Stimulsoft.System.Drawing.Image.fromFile('./assets/report/defaultLogo.png');
        varImage.valueObject = stiImage;
      }

      // Render report
      stiReport.render();
      this.viewer.report = stiReport;
      this.showMeReport = true;

      const self = this;

      setTimeout(() => {
        self.viewer.renderHtml('viewerContent');
        self.addCloseButton();
        $('body').css('overflow', 'none');
      }, 100);
    }
  }


  /*** custom button on report viewer at the top right of page ***/
  addCustomButton(viewer) {

  const userButton = viewer.jsObject.SmallButton('userButton', 'My Button', 'emptyImage');
  userButton.image.src = 'https://www.stimulsoft.com/favicon.png';
  userButton.action = function () {
    // example
    // alert("My Button Event");
  }

  const toolbarTable = viewer.jsObject.controls.toolbar.firstChild.firstChild;
  const buttonsTable = toolbarTable.rows[0].lastChild.lastChild;
  const userButtonCell = buttonsTable.rows[0].insertCell(0);
  userButtonCell.className = 'stiJsViewerClearAllStyles';
  userButtonCell.appendChild(userButton);
  }

  /*** close button on report viewer at the top right of page ***/
  addCloseButton() {

    const userButton = this.viewer.jsObject.SmallButton('userButton', 'Close', 'emptyImage');
    // userButton.image.src = "https://www.stimulsoft.com/favicon.png";
    // userButton.image.src = "https://www.stimulsoft.com/favicon.png";
    const self = this;
    userButton.action = function () {
      self.konReport = null;
      self.showMeReport = false;
      $('body').css('overflow', 'auto');
    }

    const toolbarTable = this.viewer.jsObject.controls.toolbar.firstChild.firstChild;
    const buttonsTable = toolbarTable.rows[0].lastChild.lastChild;
    const userButtonCell = buttonsTable.rows[0].insertCell(0);
    userButtonCell.className = 'stiJsViewerClearAllStyles';
    userButtonCell.appendChild(userButton);
  }

  checkAlign() {
    this.konReport.columns.forEach(column => {
      let isNumber = true;
      this.konReport.data.forEach(data => {
        if (data[column.field] && !Number(data[column.field].toString())) {
          isNumber = false;
        }
        if (isNumber) {
          column.alignData = 'right';
        }
      });
    });
  }

  onClickViewReport() {
    this.initReport();
  }

  downloadExcel() {
    if (this.filteredByExtSearch) {
      this.onDownloadExcel.emit(this.extSearchQuery);
    } else {
      this.onDownloadExcel.emit(this.filter.search);
    }
  }

  cardHomingByStore() {
    this.cardHomingOperationType.emit('3')
  }

  cardHomingByRange() {
    this.cardHomingOperationType.emit('2')
  }

  sendExtSearchQuery(event) {
    this.filteredByExtSearch = true;
    this.clearFilters();
    this.extSearchReq.emit({query: event, offset: 0, limit: 10});
  }

  convertDate(date: Date) {
    return moment(date).format('YYYY-MM-DD');
  }

  ngOnDestroy() {
    /*
    if (this.filteredByExtSearch && this.service) {
      sessionStorage.setItem(this.service.constructor.name, JSON.stringify(this.extSearchQuery));
    } else if (this.source instanceof Array) {
      sessionStorage.setItem(`${this.title}SourceFilters`, JSON.stringify(this.filter.search));
    } else if (this.source instanceof Function) {
      sessionStorage.setItem(this.service.constructor.name, JSON.stringify(this.filter.search));
    }
    */
  }

  addShowReport(showReport: Boolean) {
    if(this.showReportButton === 1){
      return true;
    } else if(this.showReportButton === 0){
      return false;
    }
    return showReport;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/kontablenew/kontablenew.component.ts